"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "VerboseFileLogReporter", {
    enumerable: true,
    get: function() {
        return VerboseFileLogReporter;
    }
});
const _formathrtime = require("@lage-run/format-hrtime");
const _isTargetStatusLogEntry = require("./isTargetStatusLogEntry.js");
const _logger = require("@lage-run/logger");
const _ansiregex = /*#__PURE__*/ _interop_require_default(require("ansi-regex"));
const _stream = require("stream");
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const stripAnsiRegex = (0, _ansiregex.default)();
function stripAnsi(message) {
    return message.replace(stripAnsiRegex, "");
}
class VerboseFileLogReporter {
    cleanup() {
        this.fileStream?.end();
    }
    log(entry) {
        // if "hidden", do not even attempt to record or report the entry
        if (entry?.data?.target?.hidden) {
            return;
        }
        // if loglevel is not high enough, do not report the entry
        if (_logger.LogLevel.verbose < entry.level) {
            return;
        }
        // log normal target entries
        if (entry.data && entry.data.target) {
            return this.logTargetEntry(entry);
        }
        // log generic entries (not related to target)
        if (entry.msg) {
            return this.print(`${entry.msg}`);
        }
    }
    printEntry(entry, message) {
        let packageAndTask = "";
        if (entry?.data?.target) {
            const { packageName, task } = entry.data.target;
            const pkg = packageName ?? "<root>";
            packageAndTask = `${pkg} ${task}`.trim();
        }
        this.print(`${this.getEntryTargetId(entry)} ${packageAndTask} ${message}`.trim());
    }
    getEntryTargetId(entry) {
        if (entry.data?.target?.id) {
            return `[:${entry.data.target.id}:]`;
        }
        return "";
    }
    print(message) {
        this.fileStream?.write(message + "\n");
    }
    logTargetEntry(entry) {
        const data = entry.data;
        if ((0, _isTargetStatusLogEntry.isTargetStatusLogEntry)(data)) {
            const { hash, duration, status } = data;
            const statusMessages = {
                running: "➔ start",
                success: `✓ done - ${duration && (0, _formathrtime.formatDuration)((0, _formathrtime.hrToSeconds)(duration))}`,
                failed: "✖ fail",
                skipped: `» skip - ${hash}`,
                aborted: "- aborted",
                queued: "… queued"
            };
            return this.printEntry(entry, statusMessages[status]);
        } else {
            const defaultMessage = `: ${stripAnsi(entry.msg)}`;
            return this.printEntry(entry, defaultMessage);
        }
    }
    summarize() {
    // No summary needed for VerboseFileLogReporter
    }
    constructor(logFile){
        _define_property(this, "fileStream", void 0);
        // if logFile is falsy (not specified on cli args), this.fileStream just become a "nowhere" stream and this reporter effectively does nothing
        if (logFile) {
            const logFilePath = _path.default.dirname(_path.default.resolve(logFile));
            if (!_fs.default.existsSync(logFilePath)) {
                _fs.default.mkdirSync(logFilePath, {
                    recursive: true
                });
            }
        }
        this.fileStream = logFile ? _fs.default.createWriteStream(logFile) : new _stream.Writable({
            write () {}
        });
    }
}
